import React from 'react';
import styled from "styled-components";

const SGrammarCondicional = styled.div`
  flex: 1;
  padding: 5px 20px;
  td { padding: 5px; }
`;

const GrammarCondicional = () => {
  return (
    <SGrammarCondicional>
<h5>Modo Condicional - Tryb warunkowy</h5>

<p>
Trybu tego używa się w wyrażeniach przypuszczenia ("na twoim miejscu zrobiłbym to"), w wyrażeniach grzecznościowych ("czy mógłbyś to zrobić?") i w II zdaniu warunkowym ("gdybym miał pieniądze, kupiłbym dobry samochód").
</p>
<p>
<b>Simple</b><br/>
<table>
<tr><td>&nbsp;</td><td nowrap><b>-ar/-er/-ir</b> (<u>entr<b>ar</b></u>)</td></tr>
<tr><td colspan="4">&nbsp;</td></tr>
<tr><td>(yo)</td>				<td>entrar<b>-ía</b></td></tr>
<tr><td>(tú)</td>			<td>entrar<b>-ías</b></td></tr>
<tr><td>(él/ella/Vd.)</td><td>entrar<b>-ía</b></td></tr>
<tr><td>(nosotros/-as)</td>		<td>entrar<b>-íamos</b></td></tr>
<tr><td>(vosotros/-as)</td>		<td>entrar<b>-íais</b></td></tr>
<tr><td nowrap>(ellos/-as/Vds.)</td>	<td>entrar<b>-ían</b></td></tr>
</table>
</p>
<p>
<b>Compuesto</b><br/>
<table>
<tr><td>(yo)</td><td><b>habría</b></td><td nowrap rowspan="6">+&nbsp;<b>Participio&nbsp;Pasado</b></td></tr>
<tr><td>(tú)</td>			<td><b>habrías</b></td></tr>
<tr><td>(él/ella/Vd.)</td><td><b>habría</b></td></tr>
<tr><td>(nosotros/-as)</td>		<td><b>habríamos</b></td></tr>
<tr><td>(vosotros/-as)</td>		<td><b>habríais</b></td></tr>
<tr><td nowrap>(ellos/-as/Vds.)</td>	<td><b>habrían</b></td></tr>
</table>
</p>
    </SGrammarCondicional>
    )
};

export default GrammarCondicional;